// Production environment configuration
export const environment = {
  production: true,
  version: require('../../package.json').version,

  // API Configuration
  apiUrl: 'https://api.getaleia.com/api',
  wsUrl: 'wss://api.getaleia.com/ws/api',
};
